import React, { useEffect, useMemo, useState } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import usePurchaseOrders from '../hooks/usePurchaseOrders';
import PurchaseOrdersGrid from '../shared/PurchaseOrdersGrid';

const PurchaseOrdersPage: React.FC = () => {
  const { data, status } = usePurchaseOrders();
  return (
    <PurchaseOrdersGrid data={data?.index} status={status} />
  );
};
export default withAuthenticationRequired(PurchaseOrdersPage);
